import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../hoc/compose';
import textLabelBase from './textLabelBase';
import displayNames from './displayNames';

var Bubble = /*#__PURE__*/function (_React$Component) {
  _inherits(Bubble, _React$Component);

  var _super = _createSuper(Bubble);

  function Bubble(props) {
    var _this;

    _classCallCheck(this, Bubble);

    _this = _super.call(this, props);

    _this.getContentRef = function (ref) {
      _this.content = ref;
    };

    _this.getContentStyle = function () {
      return _this.props.maxWidth ? _.assign({
        maxWidth: _this.props.maxWidth
      }, _this.props.contentStyle) : _this.props.contentStyle;
    };

    _this.getChildren = function () {
      if (_.isString(_this.props.children)) {
        return /*#__PURE__*/React.createElement(textLabelBase, {
          shouldTranslate: props.shouldTranslate,
          value: _this.props.children
        });
      }

      return _this.props.children;
    };

    return _this;
  }

  _createClass(Bubble, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (_.isFunction(this.props.onLayoutChange)) {
        this.props.onLayoutChange(this.content);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didTargetContentChanged = !_.isEqual(this.props.targetContent, prevProps.targetContent);
      var shouldReLayout = didTargetContentChanged || !_.isEqual(this.props.contentStyle, prevProps.contentStyle);

      if (_.isFunction(this.props.onLayoutChange) && shouldReLayout) {
        this.props.onLayoutChange(this.content);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("span", {
        className: this.props.getClassName("bubble".concat(this.props.isHint ? ' hint' : '', " arrow-").concat(this.props.arrowAlignment)),
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        onClick: this.props.onClick,
        "data-hook": this.props.dataHook
      }, /*#__PURE__*/React.createElement("div", {
        className: "bubble-content",
        ref: this.getContentRef,
        style: this.getContentStyle(),
        key: "content"
      }, this.getChildren()), this.props.arrowStyle ? /*#__PURE__*/React.createElement("div", {
        className: "bubble-arrow",
        key: "arrow",
        style: this.props.arrowStyle
      }) : null);
    }
  }]);

  return Bubble;
}(React.Component);

Bubble.displayName = displayNames.BUBBLE;
Bubble.propTypes = {
  onLayoutChange: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func,
  arrowAlignment: PropTypes.string,
  arrowStyle: PropTypes.object,
  contentStyle: PropTypes.object,
  targetContent: PropTypes.object,
  maxWidth: PropTypes.number,
  isHint: PropTypes.bool,
  dataHook: PropTypes.string
};
Bubble.defaultProps = {
  maxWidth: 240
};
export default compose(Bubble);